export default function auth({ next, store, to }) {
    if (!store.getters.isLoggedIn) {
        store.commit("SET_REDIRECT_AFTER_LOGIN", to.fullPath);
        return next({
            name: "Login",
        });
    }
    return next();
}
